import axios from 'axios';
import * as Cookies from 'js-cookie';
import StoreState from '@/assets/StoreState'

//const apiUrl = "http://localhost/b2b.pharm.gr/src/public/api";
const apiUrl = "https://api.pharm.gr/public/api";
const url = new URL(window.location.href);
const urlParam = url.searchParams.get('t');
let token = urlParam;
if (token) {
  StoreState.setAuthCookie(resp.data);
  StoreState.api.api = apiUrl
} else {
  token = Cookies.get('token');
}

let api = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
  headers: {'Authentication-Token': token}
});


export default {
  admin: 'admin',
  api: api,

  loginToAdmin(password, username) {
    console.log(username, password);
    return this.api.get("token/admin", {params: {username: username, password: password}, responseType: 'text'})

  },

  isAdminTokenValid() {
    return this.api.get("admin/", {}).then(resp => {
      if (!resp.data.error && resp.data.data.login) {
        StoreState.api.isLoggedIn = true;
        return Promise.resolve(true)
      } else {
        StoreState.api.isLoggedIn = false;
        return Promise.reject({reason: "invalidToken"})
      }
    });
  },
  resetApi() {
    let api = axios.create({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {'Authentication-Token': Cookies.get("token")}
    });
    this.api = api;
  },
  getCustomers() {
    return this.api.get('admin/customers')
  },

  getSettings() {
    return this.api.get('admin/settings')
  },

  postSetting(setting, value) {
    return this.api.post("admin/setting/" + setting, {
      value: value
    }).then(resp => {
      if (resp.data.data.success) {
        return Promise.resolve({value: true, token: resp.data.data.token});
      } else {
        return Promise.reject(resp.data.data.reason)
      }
    })
  },

  toggleOffer(offerId, status) {
    let endpoint = status ? 'activate' : 'deactivate';
    return this.api.post('admin/customer/offer/' + offerId + '/' + endpoint)
      .then(resp => {
        if (resp.data.data.success) {
          return Promise.resolve(true);
        } else {
          return Promise.reject(false)
        }
      });
  },
  getCustomerOrders(customerId) {
    return this.api.get('admin/customer/' + customerId + '/orders')
  },
  getOrderDetails(orderId) {
    return this.api.get('admin/order/' + orderId)
  },

  getAllLogs() {
    return this.api.get('admin/logs')
  },
  getOffers() {
    return this.api.get('admin/offers')
  },
  getOfferDetails(offer) {
    return this.api.get('admin/offer/' + offer)
  },
  getOfferCustomers() {
    return this.api.get('admin/customers/offers')
  },

  deleteCustomer(id) {
    return this.api.delete('admin/customer/' + id).then(
      resp => {
        console.log(resp);
        if (resp.data.data.success) {
          return Promise.resolve(true)
        } else {
          return Promise.reject(resp.data.data.reason)
        }
      }
    )
  },
  deleteExtraEmail(emailID) {
    return this.api.delete('admin/extraEmails/' + emailID).then(
      resp => {
        if (resp.data.data.success) {
          return Promise.resolve(true)
        } else {
          return Promise.reject(resp.data.data.reason)
        }
      }
    )
  },
  deleteRelation(offerId, customerID) {
    return this.api.delete('admin/customer/' + customerID + '/offer/' + offerId).then(
      resp => {
        if (resp.data.data.success) {
          return Promise.resolve(true)
        } else {
          return Promise.reject(resp.data.data.reason)
        }
      }
    )
  },
  toggleRelation(offerId, customerId) {
    return this.api.post('admin/customer/' + customerId + '/offer/' + offerId + '/toggle').then(resp => {
      if (resp.data.data.success) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(resp.data.data.reason)
      }
    })
  },
  makeRelation(offerId, customerId) {
    return this.api.post('admin/customer/' + customerId + '/offer/' + offerId).then(
      resp => {
        if (resp.data.data.success) {
          return Promise.resolve({value: true, token: resp.data.data.token});
        } else {
          return Promise.reject(resp.data.data.reason)
        }
      }
    )
  },

  getTodayLog() {
    return this.api.get('admin/logsRange')
  },
  sendEmails(offerId, customerId, emails) {
    console.log(offerId, customerId);
    return this.api.post('admin/email/customer/' + customerId + '/offer/' + offerId,
      {emails: emails})
  },

  getLogs(type, object) {


  },

  updateOfferField(id, field, value) {
    return this.api.post('admin/offer/' + id + '/' + field, {
      'value': value
    }).then(
      resp => {
        if (resp.data.data.success) {
          return Promise.resolve(true)
        } else {
          return Promise.reject(false)
        }
      }
    )
  },

  getExtraEmails(customerID) {
    return this.api.get('admin/extraEmails/' + customerID)
  },
  addExtraEmail(customerID, email) {
    return this.api.post('admin/extraEmail/', {
      CustomerID: customerID,
      Email: email,
    }).then(
      resp => {
        console.log(resp)
        if (resp.data.data.success) {
          return Promise.resolve(resp.data.data)
        } else {
          return Promise.reject(false)
        }
      });
  },

  deleteOffer(id) {
    return this.api.delete('admin/offer/' + id).then(
      resp => {
        if (resp.data.data.success) {
          return Promise.resolve(true)
        } else {
          return Promise.reject(resp.data.data.reason)
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/ApiData.js